/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QueryLeaderboardParamsPaginationDTO } from './QueryLeaderboardParamsPaginationDTO';
import {
    QueryLeaderboardParamsPaginationDTOFromJSON,
    QueryLeaderboardParamsPaginationDTOFromJSONTyped,
    QueryLeaderboardParamsPaginationDTOToJSON,
} from './QueryLeaderboardParamsPaginationDTO';

/**
 * 
 * @export
 * @interface QueryLeaderboardParamsPaginationWithContinuationTokenDTO
 */
export interface QueryLeaderboardParamsPaginationWithContinuationTokenDTO {
    /**
     * 
     * @type {QueryLeaderboardParamsPaginationDTO}
     * @memberof QueryLeaderboardParamsPaginationWithContinuationTokenDTO
     */
    pagination: QueryLeaderboardParamsPaginationDTO;
    /**
     * 
     * @type {string}
     * @memberof QueryLeaderboardParamsPaginationWithContinuationTokenDTO
     */
    continuationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryLeaderboardParamsPaginationWithContinuationTokenDTO
     */
    beforeToken?: string;
}

/**
 * Check if a given object implements the QueryLeaderboardParamsPaginationWithContinuationTokenDTO interface.
 */
export function instanceOfQueryLeaderboardParamsPaginationWithContinuationTokenDTO(value: object): value is QueryLeaderboardParamsPaginationWithContinuationTokenDTO {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function QueryLeaderboardParamsPaginationWithContinuationTokenDTOFromJSON(json: any): QueryLeaderboardParamsPaginationWithContinuationTokenDTO {
    return QueryLeaderboardParamsPaginationWithContinuationTokenDTOFromJSONTyped(json, false);
}

export function QueryLeaderboardParamsPaginationWithContinuationTokenDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryLeaderboardParamsPaginationWithContinuationTokenDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': QueryLeaderboardParamsPaginationDTOFromJSON(json['pagination']),
        'continuationToken': json['continuationToken'] == null ? undefined : json['continuationToken'],
        'beforeToken': json['beforeToken'] == null ? undefined : json['beforeToken'],
    };
}

export function QueryLeaderboardParamsPaginationWithContinuationTokenDTOToJSON(value?: QueryLeaderboardParamsPaginationWithContinuationTokenDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pagination': QueryLeaderboardParamsPaginationDTOToJSON(value['pagination']),
        'continuationToken': value['continuationToken'],
        'beforeToken': value['beforeToken'],
    };
}

